import React from "react";
import { Constent } from "../../Assets/Constants/Constent";
import {
  CloseModalIcon,
  ConfirmationIcon,
} from "../../Assets/Images/CelcomSvgImages";

const WorkOrderConfirmationModal = ({
  message,
  btnName1,
  btnName2,
  closePopup,
  showPopup,
}) => {
  if (!showPopup) return null;
  return (
    <div
      className="modal show next-page-confirmation-modal"
      id="workOrderConfirmationModal"
      style={{ display: "block" }}
      data-backdrop="static"
      data-keyboard="false"
      tabIndex="-1"
      aria-labelledby="workOrderConfirmationModalLabel"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header pb-0">
            <div className="wrapper-modal-header pt-5">
              <div className="modal-header-title-section">
                <ConfirmationIcon />
                <h5
                  className="modal-title"
                  id="workOrderConfirmationModalLabel"
                >
                  {Constent.CONFIRMATION_MODAL_TITLE}
                </h5>
                <h5 className="modal-title">{message}</h5>
              </div>
              <button
                type="button"
                className="close"
                onClick={closePopup}
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <CloseModalIcon />
                </span>
              </button>
            </div>
          </div>
          <div className="modal-body">
            <div className="wrapper-modal-body"></div>
          </div>
          <div className="modal-footer">
            <div className="refresh-btn-section" onClick={closePopup}>
              <span>{btnName1}</span>
            </div>
            <div
              className="search-btn-section"
              onClick={() => {
                closePopup();
              }}
            >
              {btnName2}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default WorkOrderConfirmationModal;
